const state = {
  token: '',
  userInfo: null
}

const getters = {
  isLoggedIn: state => !!state.token,
  role: state => state.userInfo ? state.userInfo.role : null,
  nickname: state => state.userInfo ? state.userInfo.nickname : ''
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
  },
  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo
  },
  CLEAR_USER(state) {
    state.token = ''
    state.userInfo = null
  }
}

const actions = {
  login({ commit }, { username, password }) {
    return new Promise((resolve, reject) => {
      import('@/api/auth').then(({ login }) => {
        login({ username, password })
          .then(data => {
            commit('SET_TOKEN', data.token)
            commit('SET_USER_INFO', data.userInfo)
            localStorage.setItem('wublog_token', data.token)
            resolve(data)
          })
          .catch(error => reject(error))
      })
    })
  },

  register({ commit }, data) {
    return new Promise((resolve, reject) => {
      import('@/api/auth').then(({ register }) => {
        register(data).then(() => resolve()).catch(error => reject(error))
      })
    })
  },

  getUserInfo({ commit }) {
    return new Promise((resolve, reject) => {
      import('@/api/auth').then(({ getUserInfo }) => {
        getUserInfo()
          .then(data => {
            commit('SET_USER_INFO', data)
            resolve(data)
          })
          .catch(error => reject(error))
      })
    })
  },

  logout({ commit }) {
    commit('CLEAR_USER')
    localStorage.removeItem('wublog_token')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
